/**
 * Shared "EDDY · by Blockbrain" footer pill. Used by the auth shell and
 * the public /apps gallery so they read identically over the brand-image
 * band at the bottom of both surfaces.
 *
 * Position is left to the caller — auth-layout pins it absolutely, the
 * /apps page renders it inside flow at the bottom of the page.
 */

import { Tip } from '~/components/ui/tip';
export function BrandFooterPill() {
  return (
    <Tip label="Powered by Blockbrain">
      <a
        href="https://theblockbrain.ai"
        target="_blank"
        rel="noreferrer"
        className="pointer-events-auto inline-flex items-center gap-2 px-3 py-1 rounded-full border border-border/60 bg-card/70 backdrop-blur-md text-[length:var(--text-2xs)] text-muted-foreground shadow-sm hover:bg-card hover:text-foreground transition-colors"
      >
        <span className="font-semibold tracking-tight text-foreground/80">EDDY</span>
        <span className="opacity-50">·</span>
        <span>by</span>
        <img
          src="/blockbrain-logo-dark.png"
          alt=""
          aria-hidden
          width={14}
          height={14}
          className="dark:invert"
        />
        <span className="font-medium text-foreground/80">Blockbrain</span>
      </a>
    </Tip>
  );
}
